import { toneVariant, useCompanionNoun } from '@/utils/personalization'
import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import type { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  {
    emoji: '🌅',
    title: 'pages.onboarding.availability.morning',
    value: 'morning',
  },
  {
    emoji: '☀️',
    title: 'pages.onboarding.availability.midday',
    value: 'midday',
  },
  {
    emoji: '🌆',
    title: 'pages.onboarding.availability.evening',
    value: 'evening',
  },
  { emoji: '🌙', title: 'pages.onboarding.availability.night', value: 'night' },
  {
    emoji: '🕐',
    title: 'pages.onboarding.availability.anytime',
    value: 'anytime',
  },
]

export default function AvailabilityQuestionPage() {
  const noun = useCompanionNoun()

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title={toneVariant('pages.onboarding.availability.title')}
      subtitle={toneVariant('pages.onboarding.availability.subtitle')}
      translationInterpolation={{ noun }}
    />
  )
}
